module.exports = __webpack_public_path__ + "static/img/NewsImage2.0315185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/news/NewsImage2.png
// module id = yBFd
// module chunks = 1